import React from "react";

/**
 * ProgressBar Component
 *
 * Visual progress indicator with site-cohesive styling
 * Uses dark for current step, emerald green for completed
 */
export default function ProgressBar({ currentStep, totalSteps }) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div style={{ marginBottom: "32px" }}>
      {/* Step labels */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        {Array.from({ length: totalSteps }, (_, i) => {
          const stepNum = i + 1;
          const isCompleted = stepNum < currentStep;
          const isCurrent = stepNum === currentStep;

          return (
            <div
              key={stepNum}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 1,
              }}
            >
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                  backgroundColor: isCompleted
                    ? "#36454F"
                    : isCurrent
                      ? "#1a1a1a"
                      : "#e5e5e5",
                  color: isCompleted || isCurrent ? "#fff" : "#a3a3a3",
                  boxShadow: isCurrent ? "0 2px 8px rgba(26, 26, 26, 0.15)" : "none",
                }}
              >
                {isCompleted ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  stepNum
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Progress bar track */}
      <div
        style={{
          height: "4px",
          backgroundColor: "#e5e5e5",
          borderRadius: "2px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            backgroundColor: "#36454F",
            borderRadius: "2px",
            transition: "width 0.5s ease",
          }}
        />
      </div>
    </div>
  );
}
